import apiClient from './api';
import { t } from 'i18n';

/** R6 category experience modules -- every call returns
 * { success: true, data } or { success: false, error } (never throws). */
async function call(promise, fallbackKey = 'modules.errors.load') {
  try {
    const response = await promise;
    return { success: true, data: response.data };
  } catch (error) {
    const detail = error.response?.data?.detail;
    return { success: false, status: error.response?.status, error: typeof detail === 'string' ? detail : t(fallbackKey) };
  }
}

let registryPromise = null;

export const ModulesService = {
  /** The module registry (field schemas) -- same for everyone, fetched once. */
  getRegistry() {
    if (!registryPromise) {
      registryPromise = call(apiClient.get('/modules')).then((res) => {
        if (!res.success) registryPromise = null;
        return res;
      });
    }
    return registryPromise;
  },
  getBatch: (code) => call(apiClient.get(`/batches/${encodeURIComponent(code)}`)),
};

export const VendorModulesService = {
  getMine: () => call(apiClient.get('/vendor/modules')),
  listSizeCharts: () => call(apiClient.get('/vendor/size-charts')),
  createSizeChart: (name, rows) => call(apiClient.post('/vendor/size-charts', { name, rows }), 'modules.errors.save'),
  updateSizeChart: (id, name, rows) => call(apiClient.put(`/vendor/size-charts/${id}`, { name, rows }), 'modules.errors.save'),
  deleteSizeChart: (id) => call(apiClient.delete(`/vendor/size-charts/${id}`), 'modules.errors.save'),
  markReady: (voId) => call(apiClient.post(`/vendor/vendor-orders/${voId}/ready`), 'modules.errors.save'),
};

export const RecipesService = {
  list: () => call(apiClient.get('/me/recipes')),
  save: (productId, modifiers) => call(apiClient.put(`/me/recipes/${productId}`, { modifiers }), 'modules.errors.save'),
  remove: (productId) => call(apiClient.delete(`/me/recipes/${productId}`), 'modules.errors.save'),
};

export const AdminModulesService = {
  setCategoryModule: (categoryId, module, reason) =>
    call(apiClient.put(`/admin/categories/${categoryId}/module`, { module: module || null, reason: reason || null }),
      'modules.errors.save'),
};

/** URL of a batch's QR code (SVG, served by the API). */
export function batchQrUrl(code) {
  const base = (apiClient.defaults.baseURL || '').replace(/\/$/, '');
  return `${base}/batches/${encodeURIComponent(code)}/qr.svg`;
}

/** Extra unit price from chosen food add-ons (display only; the server prices the order). */
export function addonsTotal(attributes, modifiers) {
  const addons = attributes?.addons || [];
  const chosen = new Set(modifiers?.addons || []);
  return addons.filter((a) => chosen.has(a.name)).reduce((sum, a) => sum + Number(a.price || 0), 0);
}

export function hasModifiers(modifiers) {
  return Boolean(modifiers && ((modifiers.remove || []).length || (modifiers.addons || []).length));
}
